import { useNavigate, useParams } from "react-router-dom";
import VisitSummaryCard from "../components/visits/visit-summary-card";
import MedicalRecordsSection from "../components/medical-records/medical-records-section";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadVisits from "../hooks/useLoadVisits";
import { buildRecordDetailPath } from "#/lib/medicalRecords";

const VisitsPage = () => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();
  const { visits, isLoading, error } = useLoadVisits(userId);
  useSetPageContext(visits);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta">
          Failed to load visits
        </Typography>
      </div>
    );
  }

  const hasVisits = visits.length > 0;

  return (
    <MedicalRecordsSection
      title="Visits"
      buttonLabel="Add Visit"
      uploadMessage={`Add visit to this user's medical records ${userId ?? ""}`}
      hasRecords={hasVisits}
      emptyTitle="No visits listed."
    >
      {hasVisits
        ? visits.map((v) => (
            <div
              key={v.id}
              id={`record-visit-${v.id}`}
              className="file-record-anchor block scroll-mt-24"
            >
              <VisitSummaryCard
                visit={v}
                onClick={() => {
                  const detailPath = buildRecordDetailPath(
                    "visits",
                    v.id,
                    userId
                  );
                  if (!detailPath) return;
                  navigate(detailPath, { state: { record: v } });
                }}
              />
            </div>
          ))
        : null}
    </MedicalRecordsSection>
  );
};

export default VisitsPage;
